import React, { useState } from "react";
import OrphanHealthStatus from "./OrphanHealthStatus";
import EducationalStatus from "./EducationalStatus";
import OrphanCare from "./OrphanCare";
import { Collapse } from "antd";
import userIcon from "../../../../assets/icons/user.svg";

const { Panel } = Collapse;

interface OrphanInfoProps {
  diseaseType: any;
  academicLevel: any;
  academicYears: any;
  academicsPerformance: any;
  educational: any;
  orphansBeneficiaryInfo: any;
  healthStates: any;
  disabilityTypes: any;
  banks: any;
  form: any;
}

const OrphanInfo = ({
  diseaseType,
  academicLevel,
  academicYears,
  academicsPerformance,
  educational,
  orphansBeneficiaryInfo,
  healthStates,
  disabilityTypes,
  banks,
  form,
}: OrphanInfoProps) => {
  const [active, setActive] = useState<any>("0");

  return (
    <div style={{ padding: "2rem" }}>
      <Collapse
        className="takaful--collapse-recipient"
        accordion
        activeKey={active}
        onChange={(key) => setActive(key)}
      >
        {orphansBeneficiaryInfo &&
          orphansBeneficiaryInfo?.beneficiary_orphan_ids?.map(
            (el: any, key: any) => (
              <>
                <Panel
                  className="takaful--header-recipient-Panel"
                  key={key}
                  header={
                    <div className="takaful--header-recipient-container">
                      <div className="takaful--header-recipient-collapse">
                        <img
                          src={userIcon}
                          alt="userIcon"
                          className="userIcon"
                        />
                        <span className="takaful--add-recipient-title">
                          {el.name}
                        </span>
                      </div>
                    </div>
                  }
                >
                  <OrphanHealthStatus
                    diseaseType={diseaseType}
                    healthStates={healthStates}
                    disabilityTypes={disabilityTypes}
                    form={form}
                    index={key}
                  />
                  <EducationalStatus
                    academicLevel={academicLevel}
                    academicYears={academicYears}
                    academicsPerformance={academicsPerformance}
                    educational={educational}
                    form={form}
                    index={key}
                  />
                  <OrphanCare
                    index={key}
                    form={form}
                    banks={banks}
                    orphan={el}
                  />
                </Panel>
              </>
            )
          )}
      </Collapse>
    </div>
  );
};

export default OrphanInfo;
